common.View.create('galaxy::common.form.inputs.Tags', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad() {
		this.initTags();
	},

	initTags()
	{
		// Get the input that needs to be converted to the tags input
		let $input = this.element.find('select');

		// Set tag input options
		let tagInputOptions = {
			confirmKeys: [13, 188],
		};

		// Add additional options to the tag input
		this.addTagInputOptions($input, tagInputOptions);

		// Set tags on input with typeahead
		$input.tagsinput(tagInputOptions);

		// Set input where user types
		let $typeInput = this.element.find('.tt-input, .bootstrap-tagsinput input');

		// Add current values to tagsinput
		$.each($input.data('values'), function(index, value) {
			$input.tagsinput('add', value);
		});

		// Disable form submit on enter; Separate because otherwise this doesn't work
		$typeInput
			.on('keypress', (e) => {
				// If enter is pressed
				if ( e.key === 'Enter' ) {
					// Select first suggestion
					this.element.find('.tt-suggestion:first-child').trigger('click');

					e.preventDefault();
				}
			});
	},

	addTagInputOptions($input, tagInputOptions)
	{
		// Has typeahead and autocomplete? If so don't allow free input and only show typeahead autocomplete
		if( $input.data('autocomplete') && $input.data('typeahead') ) {
			// Set typeahead
			this.initTypeahead($input, tagInputOptions);

			// Don't allow free input
			tagInputOptions.freeInput = false;
		}

		// Check multiple dimensional
		if( $.isArray( $input.data('autocomplete') ) &&
			$input.data('autocomplete')[0] && $input.data('autocomplete')[0].constructor !== String ) {
			tagInputOptions.itemValue = $input.data('value') || 'id';
			tagInputOptions.itemText = $input.data('key') || 'name';
		}
	},

	initTypeahead($input, tagInputOptions)
	{
		let bhOptions = {
			local: $input.data('autocomplete'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			datumTokenizer: Bloodhound.tokenizers.whitespace
		};

		// Check if multiple dimensional array is given; then take given value or take name by default
		if( $.isArray($input.data('autocomplete')) &&
			$input.data('autocomplete')[0] && $input.data('autocomplete')[0].constructor !== String ) {
			bhOptions.datumTokenizer = Bloodhound.tokenizers.obj.whitespace( $input.data('value') || 'name' );
		}

		// Initialize bloodhound
		let bh = new Bloodhound(bhOptions);
		bh.initialize();

		// Set typeahead autocomplete (into variable)
		let typeahead = {
			source: bh.ttAdapter(),
			afterSelect: function () {
				this.$element[0].value = '';
			}
		};

		// Check if multiple dimensional array is given; then take given value or take name and id by default
		if( $.isArray( $input.data('autocomplete') ) &&
			$input.data('autocomplete')[0] && $input.data('autocomplete')[0].constructor !== String ) {
			typeahead.displayKey = $input.data('value') || 'name';
			typeahead.displayValue = $input.data('value') || 'id';
		}

		// Add to tag input options
		tagInputOptions.typeaheadjs = typeahead;
	}

});
